import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		// eslint-disable-next-line jira/ff/no-preconditioning
		return fg('jira_list_conditional_formatting') && fg('saved_list_view_technical_changes');
	},
};
